module.exports = __webpack_public_path__ + "static/media/the-camogie-association.6af3a036.jpg";